var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1027.005,
    height: 897.13,
    viewBox: "0 0 271.728 237.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(359.674 15.532)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 16,
    d: "M-116.362 69.605l-44.393-76.67h-126.11l-48.377 83.89 64.295 108.716h94.244l47.121-82.066"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 16,
    d: "M-330.49 137.548l43.625 75.819h126.11l47.362-82.677-63.31-109.282h-94.244l-47.915 82.991"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.5,
    strokeOpacity: 1,
    strokeWidth: 18,
    d: "M-255.327 132.341l.204-60.7 30.987 34.716 31.593-35.905-.293 61.951"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.02dbc50f0ddc1e98806c2fa35a405479.svg";
export { ForwardRef as ReactComponent };